import "./tooltip.scss";

type IProps = {
  text: string;
};

export default function Tooltip({ text }: IProps) {
  return (
    <div className="tooltip-wrap">
      <span />
      <div>{text}</div>
    </div>
  );
}
